import { createSlice } from '@reduxjs/toolkit';
import { sessionInitialState } from '../state';
import { clearRedirectUrl } from '../../utils/sessionTimeout';
import { clearAuthCookies } from '../../utils/cookieUtils';

const session = createSlice({
    name: 'session',
    initialState: sessionInitialState,
    reducers: {
        updateUser(state, action) {
            state.user = action.payload;
        },
        logout(state, action) {
            clearRedirectUrl();
            clearAuthCookies();
        },
        updateName(state, action) {
            const { firstName, lastName } = action.payload;
            state.user.firstName = firstName;
            state.user.lastName = lastName;
        },
    },
});

export const { updateUser, logout, updateName } = session.actions;

export default session.reducer;
